import "../index.css";
import Nav from "./navbar";
import BlogIntro from "./BlogIntro";
import Footer from "./footer";

import "../styles.css";
import "../popup.css";
import "../try.css";

function Blogs() {
  function componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidMount();
  return (
    <>
      <Nav />
      <BlogIntro />
      <Footer />
    </>
  );
}

export default Blogs;
